import React, { useLayoutEffect, useRef } from 'react';
import { PLANTING_FLOW_STEPS, stripStepIdForScreen } from './plantingFlowUtils';

/**
 * Five-step strip shown only inside the planting plan flow (handoff §3.3).
 */
export function PlantingPlanStepStrip({
  activeScreen = 'ground',
  onAllPlans,
  onStepSelect,
}) {
  const activeStripId = stripStepIdForScreen(activeScreen);
  const stepsRef = useRef(null);

  useLayoutEffect(() => {
    const scroller = stepsRef.current;
    const active = scroller?.querySelector('.plant-flow-strip__step.is-active');
    if (!scroller || !active || typeof scroller.scrollTo !== 'function') return;
    const left = active.offsetLeft - (scroller.clientWidth - active.offsetWidth) / 2;
    scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }, [activeStripId]);

  return (
    <div className="plant-flow-strip" data-testid="plant-flow-step-strip">
      <button
        type="button"
        className="plant-flow-strip__all"
        data-testid="plant-flow-all-plans"
        onClick={onAllPlans}
      >
        <span className="plant-flow-strip__all-mark" aria-hidden="true">‹</span>
        ALL PLANS
      </button>
      <div
        ref={stepsRef}
        className="plant-flow-strip__steps"
        role="tablist"
        aria-label="Planting plan steps"
      >
        {PLANTING_FLOW_STEPS.map((step) => {
          const isActive = activeStripId === step.id;
          return (
            <button
              key={step.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-label={`${step.num} ${step.label}`}
              className={`plant-flow-strip__step${isActive ? ' is-active' : ''}`}
              data-testid={`plant-flow-step-${step.id}`}
              onClick={() => onStepSelect(step.id)}
            >
              <span className="plant-flow-strip__num" aria-hidden="true">{step.num}</span>
              {step.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
